import Form from "ui/nvrs/create-form";
import Breadcrumbs from "ui/sites/breadcrumbs";
import StepProgressbar from "ui/customers/step-progressbar";
import { useParams } from "react-router-dom";
import TopNav from "ui/dashboard/topnav";


export default function Page() {
  const { orgid, siteid } = useParams();
  const orgId = orgid!;
  const siteId = siteid!;

  return (
    <>
      <TopNav title="Customer Management" />
      <div className="flex-grow pr-6 pb-6">
        <div className="w-full h-full p-6 rounded-3xl bg-white">
          <StepProgressbar step={3} />
          <Form orgId={orgId} siteId={siteId} />
        </div>
      </div>
    </>
  );
}
